import Axios from "axios";
import {
    SET_INV_GATE_PASS_LIST,
    UNSET_INV_GATE_PASS_LIST,
    SET_EDITING_INV_GATE_PASS_LIST,
    UNSET_EDITING_INV_GATE_PASS_LIST,
} from "@/store/mutation-types";
import {
    saveUpdateInvGatePass,
    getInvGatePassList,
    getInvGatePassById as getInvGatePassByIdApi,
} from "@/store/api";

const state = {
    getInvGatePassList: [],
    editingInvGatePass: null,
};

const getters = {
    getInvGatePassList(state) {
        return state.getInvGatePassList;
    },
    getEditingGatePass: (state) => {
        return state.editingInvGatePass;
    },
};

const mutations = {
    [SET_INV_GATE_PASS_LIST](state, data) {
        state.getInvGatePassList = data;
    },
    [UNSET_INV_GATE_PASS_LIST](state) {
        state.getInvGatePassList = [];
    },
    [SET_EDITING_INV_GATE_PASS_LIST](state, GatePass) {
        state.editingGatePass = GatePass;
    },
    [UNSET_EDITING_INV_GATE_PASS_LIST](state) {
        state.editingGatePass = null;
    },
};

const actions = {
    saveUpdateInvGatePass({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateInvGatePass, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getInvGatePassList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvGatePassList, data)
                .then(function (response) {
                    commit("SET_INV_GATE_PASS_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_INV_GATE_PASS_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },

    getInvGatePassById({ commit }, id) {
        const getInvGatePassById = `${getInvGatePassByIdApi}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getInvGatePassById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
